//@flow

import React, { Component } from 'react';

import config from '../../config';
import type { Image } from '../../types/image';

type Props = {
  images: Image,
  name: string,
  defaultImageURI?: string,
  showImageType: string,
  timeoutBlur: number,
};

type State = { loaded: boolean };

export default class ImageWithBlur extends Component<Props, State> {
  static defaultProps = { defaultImageURL: '' };

  styles = {
    blur: { filter: 'blur(15px)', transition: 'all 1s' },
    noBlur: { transition: 'all 3s' },
  };

  state = { loaded: false };

  whenLoaded = () => {
    setTimeout(() => this.handleBlur(), this.props.timeoutBlur);
    this.setState({ loaded: true });
  };

  handleBlur = () => {
    const { images, showImageType } = this.props;

    if (this.imageRef && images) {
      this.imageRef.src = `${config.RESOURCE_URL}/${images[showImageType]}`;
      this.imageRef.style = this.styles.noBlur;
    }
  };

  render() {
    const { defaultImageURI, images, name } = this.props;
    const { loaded } = this.state;
    let mediumImage, largeImage;

    if (images) {
      mediumImage = `${config.RESOURCE_URL}/${images.medium}` || defaultImageURI;
      largeImage = `${config.RESOURCE_URL}/${images.large}` || defaultImageURI;
    }

    return (
      <picture>
        {/* <source srcSet={smallImage} media="(max-width: 767px)" /> */}
        {loaded ? (
          <img alt={name} src={largeImage} style={this.styles.noBlur} />
        ) : (
          <img
            alt={name}
            src={mediumImage}
            ref={img => {
              this.imageRef = img;
            }}
            style={this.styles.blur}
            onLoad={this.whenLoaded}
          />
        )}
      </picture>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/ImageWithBlur.jsx